export default "__VITE_ASSET__BIlTtAaQ__"